import { Center, useTheme, VStack } from '@wegroup/design-system';
import React, { PropsWithChildren } from 'react';
import { isSocialLoginUrl } from '../../../../../../app/src/features/authentication/constants/SocialAuth';
import NewConversationButton from '../../../../../../flows/src/components/ui/advisory-flow/components/toolbar/NewConversationButton';
import useIsNewRoute from '../../hooks/useIsNewRoute';
import useIsSelectedOffersPage from '../../hooks/useIsSelectedOffersPage';
import OffersSidebarBackButton from './OffersSidebarBackButton';
import OffersSidebarSelectedOffersButton from './OffersSidebarSelectedOffersButton';
import OffersSidebarPriceSummary from './price-summary/OffersSidebarPriceSummary';
import OffersSidebarRiskObjects from './risk-objects/OffersSidebarRiskObjects';

const OffersSidebar: React.FC = () => {
  const { space } = useTheme();
  const isSelectedOffersPage = useIsSelectedOffersPage();
  const isNewRoute = useIsNewRoute();
  const isOfferPage = !!window.location.pathname.match(
    new RegExp('/sales-conversation/(offers).*') || false,
  );

  return (
    <VStack
      spacing="4"
      w={`calc(100% + ${space[10]})`}
      h="100%"
      flexDirection="column"
      justify="center"
      pos="absolute"
      right="-10"
    >
      <CenterOffset>
        <OffersSidebarBackButton />
      </CenterOffset>
      <OffersSidebarRiskObjects />
      {!isNewRoute && (
        <CenterOffset>
          <OffersSidebarSelectedOffersButton />
        </CenterOffset>
      )}
      {isSelectedOffersPage && <OffersSidebarPriceSummary show />}
      {isSocialLoginUrl && isOfferPage && <NewConversationButton />}
    </VStack>
  );
};

const CenterOffset: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Center w="full" pr="6" flexDir="column">
      {children}
    </Center>
  );
};

export default OffersSidebar;
